import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";
import { getAnalytics } from"firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyD06K4HV5hMdH4VkVq8-def4NwHUo3Xbtw",
    authDomain: "crosswordgame-c3747.firebaseapp.com",
    projectId: "crosswordgame-c3747",
    storageBucket: "crosswordgame-c3747.appspot.com",
    messagingSenderId: "1062447986014",
    appId: "1:1062447986014:web:f1e411a21b0b75afc5cbcf",
    measurementId: "G-S0M9N02DL3"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const storage = getStorage(app);
const firestore = getFirestore(app);
const functions = getFunctions(app);

export { auth, storage, firestore, functions, analytics };
